import React, { useState } from "react";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import ToolCallBlock from "./ToolCallBlock";
import {
  ExpandLessRounded,
  ExpandMoreRounded,
  TerminalRounded,
} from "@mui/icons-material";
import { Timeline } from "@mui/lab";
import { TimelineItemWrapper } from "./ToolCallBlock";

function Toolcalls({ blocks, isStreaming = false, hasNextGroup = false }) {
  const theme = useTheme();
  const [expanded, setExpanded] = useState(false);
  return (
    <Box borderRadius={2} bgcolor={theme.palette.background.light} mb={2}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={1.5}
        sx={{
          cursor: "pointer",
        }}
        onClick={() => setExpanded((prev) => !prev)}>
        <Box display="flex" alignItems="center" gap={1}>
          <TerminalRounded sx={{ fontSize: 16 }} />
          <Typography variant="body2">AI Thoughts</Typography>
        </Box>
        <IconButton size="small" edge="end">
          {expanded ? (
            <ExpandLessRounded sx={{ fontSize: 16 }} />
          ) : (
            <ExpandMoreRounded sx={{ fontSize: 16 }} />
          )}
        </IconButton>
      </Box>
      {expanded && (
        <Box p={1.5} pb={2} pt={0}>
          <Timeline
            sx={{
              padding: 0,
              margin: 0,
              "& .MuiTimelineItem-root": {
                // minHeight: 0,
                "&::before": {
                  display: "none",
                },
              },
              "& .MuiTimelineContent-root": {
                // padding: 0,
              },
            }}>
            {blocks.map(({ block, originalIndex }, index) => {
              return (
                <TimelineItemWrapper isLast={index === blocks.length - 1}>
                  <ToolCallBlock
                    key={originalIndex}
                    block={block}
                    isStreaming={isStreaming}
                    showIcon={false}
                  />
                </TimelineItemWrapper>
              );
            })}
          </Timeline>
        </Box>
      )}
      {!hasNextGroup && !expanded && (
        <Box p={1.5} pb={2} pt={0}>
          <ToolCallBlock
            block={blocks[blocks.length - 1].block}
            isStreaming={isStreaming}
            showIcon={true}
          />
        </Box>
      )}
    </Box>
  );
}

export default Toolcalls;
